import * as React from "react"
import { useHistory } from 'react-router-dom';
import axios from '../services/index'

//This component show up when user finish the payment process, telling him if it succeed or not, and in case of success, manage the request to send mails to user and admin about the purchase.
export const BuySuccess: React.FunctionComponent = (props) => {
    const trainingId = window.location.href.toString().split('/')[5]
    const checkoutId = window.location.href.toString().split('=')[1]
    const userId = localStorage.getItem('userId')
    const userName = localStorage.getItem('username')
    const currentToken = localStorage.getItem('access_token')
    const nameLastname = localStorage.getItem('nameLastname')
    let history = useHistory()
    const [trainingName, setTrainingName] = React.useState('')
    const [trainingPrice, setTrainingPrice] = React.useState('')
    const [trainingPaid, setTrainingPaid] = React.useState("unset")


    React.useEffect(() => {
        if(checkoutId){
            axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/paymentCheck/${checkoutId}`)
            .then(function(response) {
                let buyDate: any = response.data.date
                let nameTraining: any = ''
                let priceTraining: any = ''
                if (response.data.status === "PAID") {
                    setTrainingPaid("success")
                    axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/training/${trainingId}`)
                    .then(function(response) {
                        setTrainingName(response.data.title)
                        nameTraining = response.data.title
                        setTrainingPrice(response.data.price)
                        priceTraining = response.data.price
                        let userList = []
                        if (response.data.allowedUsers) {
                            userList = response.data.allowedUsers
                        }
                        userList.push(`https://LaurenceBrun.eu.pythonanywhere.com/users/${userId}/`)
                        axios.patch(`https://LaurenceBrun.eu.pythonanywhere.com/paidtraining/${trainingId}/`, {
                            "allowedUsers": userList,
                        }, {
                            headers: {
                                "Authorization" : `Bearer ${currentToken}`
                            }
                        })
                        .then(function(response) {
                            sendMails(buyDate, nameTraining, priceTraining)
                            setTimeout(()=>{history.push(`/training/${trainingId}/`)}, 10000)
                        })
                        .catch(function(error) {
                            alert("Votre paiement a bien abouti mais une erreur est survenue lors de l'ajout de votre formation à vos formations possédées. Contactez l'administrateur avec vos informations de paiement !")
                        })
                    })
                    .catch(function(error) {
                        alert("Votre paiement a bien abouti mais une erreur est survenue lors de l'ajout de votre formation à vos formations possédées. Contactez l'administrateur avec vos informations de paiement !")
                    })
                }
                else {
                    setTrainingPaid("fail")
                }
            })
            .catch(function(error){
                alert("Une erreur est survenue au cours de la transaction !")
            })
        }    
        else{
            setTrainingPaid("fail")
        }   
    }, [])

    const sendMails = (buyDate: any, nameTraining: any, priceTraining: any) => {
        axios.post(
            `https://LaurenceBrun.eu.pythonanywhere.com/sendBuyMail/`,
            {
                "name" : nameTraining,
                "price" : priceTraining,
                "trainingUrl" : `http://en-deuil-et.com/eformations/training/${trainingId}/`,
                "user" : userName,
                "userIdentity": nameLastname,
                "time" : buyDate
            },
            {
                headers: {
                    "Authorization" : `Bearer ${currentToken}`
                }
            })
            .then(function(response) {
                localStorage.removeItem('nameLastname')
            })
            .catch(function(error) {
                localStorage.removeItem('nameLastname')
                alert("Une erreur est survenue au cours du processus d'envoi de l'e-mail récapitulant votre achat ! Contactez l'administrateur avec vos informations de paiement si nécessaire.")
            })
    }

    if (trainingPaid === "success") {
        return(
            <div>
                <h3 className="BuyH3"><span className="BuyH3SubPart">Succès !</span><br /> Vous avez acheté la formation <span className="BuyH3SubPart">{trainingName}</span> pour le prix de <span className="BuyH3SubPart">{trainingPrice}€</span>. </h3>
                <div>Vous allez être redirigé vers votre formation dans quelques instants...</div>
            </div>  
        )
    }
    else if(trainingPaid === "fail") {
        return(
            <div>
                <span>Une erreur est survenue durant le paiement !</span>
            </div>
        )
    }
    else {
        return(
            <div>

            </div>
        )
    }
}
